import React from 'react';

interface KustomLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const KustomLogo: React.FC<KustomLogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <svg
        viewBox="0 0 100 30"
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background rounded rectangle */}
        <rect
          x="2"
          y="2"
          width="96"
          height="26"
          rx="4"
          ry="4"
          fill="#ffb3c6"
          stroke="#ffb3c6"
        />

        {/* Kustom text */}
        <text
          x="50"
          y="20"
          textAnchor="middle"
          fontSize="14"
          fontWeight="bold"
          fill="#000000"
          fontFamily="Arial, sans-serif"
        >
          Kustom.
        </text>
      </svg>
    </div>
  );
};

export default KustomLogo;


